export const routes = Object.freeze({
  home: '/home',
  prysm: '/prysm',
  about: '/about',
  thankyou: '/thankyou',
});
